import axios from 'axios';
import * as types from '../constants/ActionTypes';
import Page from '../../lib/page';
import { isDisputeAlertEnabled } from '../../lib/TrackersHelper';

function requestOpenDisputeChecker() {
  return { type: types.REQUEST_OPEN_DISPUTE };
}

function receiveOpenDisputeCheckerError() {
  return { type: types.RECEIVE_OPEN_DISPUTE_ERROR };
}

function receiveOpenDispute(payload) {
  return { type: types.RECEIVE_OPEN_DISPUTE, payload };
}

export default function getOpenDisputes() {
  const unsupportedBrowser = Page.isunSupportedBrowser();
  return (dispatch) => {
    if (unsupportedBrowser || !isDisputeAlertEnabled()) {
      // If browser is not supported for dispute tracker do not trigger dispute API call
      return dispatch(receiveOpenDisputeCheckerError());
    }
    dispatch(requestOpenDisputeChecker());
    return axios.get('/smarthelp/get-dispute-transactions')
      .then((response) => {
        let disputes = [];
        if (response.data) {
          disputes = (response.data && response.data.disputes && response.data.disputes.items) ? response.data.disputes.items : [];
        }
        dispatch(receiveOpenDispute(disputes));
      })
      .catch(() => {
        dispatch(receiveOpenDisputeCheckerError());
      });
  };
}
